import { render, staticRenderFns } from "./OrderColportajeTransferModalComponent.vue?vue&type=template&id=4e3de149&"
import script from "./OrderColportajeTransferModalComponent.vue?vue&type=script&lang=js&"
export * from "./OrderColportajeTransferModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports